import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Card,
  Typography,
  Spin,
  Table,
  Tag,
  Statistic,
} from 'antd';
import {
  TeamOutlined,
  CodeSandboxOutlined,
  ShoppingCartOutlined,
  DollarOutlined,
} from '@ant-design/icons';
import { fetchDashboard } from '../../store/slices/adminSlice';
import ErrorMessage from '../common/ErrorMessage';

const { Title, Text } = Typography;

const Dashboard = () => {
  const dispatch = useDispatch();
  const { dashboard, loading, error } = useSelector((state) => state.admin);

  useEffect(() => {
    dispatch(fetchDashboard());
  }, [dispatch]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
        <Spin size="large" tip="Yuklanmoqda..." />
      </div>
    );
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  const stats = [
    {
      title: 'Foydalanuvchilar',
      value: dashboard.totalUsers || 0,
      icon: <TeamOutlined style={{ fontSize: 32, color: '#1890ff' }} />,
      color: '#1976d2',
    },
    {
      title: 'Mahsulotlar',
      value: dashboard.totalProducts || 0,
      icon: <CodeSandboxOutlined style={{ fontSize: 32, color: '#52c41a' }} />,
      color: '#2e7d32',
    },
    {
      title: 'Buyurtmalar',
      value: dashboard.totalOrders || 0,
      icon: <ShoppingCartOutlined style={{ fontSize: 32, color: '#fa8c16' }} />,
      color: '#ed6c02',
    },
    {
      title: 'Jami tushum',
      value: `${(dashboard.revenue || 0).toLocaleString()} UZS`,
      icon: <DollarOutlined style={{ fontSize: 32, color: '#722ed1' }} />,
      color: '#9c27b0',
    },
  ];

  const orderStatusLabels = {
    pending: 'Kutilmoqda',
    confirmed: 'Tasdiqlangan',
    processing: 'Jarayonda',
    shipped: 'Yetkazilmoqda',
    delivered: 'Yetkazildi',
    cancelled: 'Bekor qilindi',
    completed: 'Bajarildi'
  };

  const orderStatusColumns = [
    {
      title: 'Holati',
      dataIndex: 'status',
      key: 'status',
      render: (text) => <Tag color="blue">{orderStatusLabels[text] || text}</Tag>,
    },
    {
      title: 'Soni',
      dataIndex: 'count',
      key: 'count',
      align: 'right',
    },
  ];

  const recentOrdersColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      render: (id) => `#${id}`,
    },
    {
      title: 'Mijoz',
      key: 'customer',
      render: (_, record) => (
        record.customer ? `${record.customer.first_name} ${record.customer.last_name}` : 'Mavjud emas'
      ),
    },
    {
      title: 'Jami',
      dataIndex: 'total_amount',
      key: 'total_amount',
      render: (amount) => `${(amount || 0).toLocaleString()} UZS`,
    },
    {
      title: 'Sana',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => date ? new Date(date).toLocaleString('uz-UZ') : '-',
    },
    {
      title: 'Holati',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color = 'default';
        if (status === 'completed' || status === 'delivered') color = 'success';
        if (status === 'pending') color = 'warning';
        if (status === 'cancelled') color = 'red';
        return <Tag color={color}>{orderStatusLabels[status] || status}</Tag>;
      },
    },
  ];

  return (
    <div>
      <Title level={2} style={{ marginBottom: 24 }}>
        Admin paneli
      </Title>

      {/* Statistics Cards */}
      <Row gutter={[16, 16]} style={{ marginBottom: 32 }}>
        {stats.map((stat, index) => (
          <Col xs={24} sm={12} md={6} key={index}>
            <Card bordered={false} bodyStyle={{ padding: 24 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Statistic title={stat.title} value={stat.value} />
                {stat.icon}
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <Row gutter={[24, 24]}>
        {/* Orders by Status */}
        <Col xs={24} md={12}>
          <Card title="Buyurtmalar holati bo'yicha" bordered={false}>
            <Table
              columns={orderStatusColumns}
              dataSource={dashboard.ordersByStatus}
              rowKey="status"
              pagination={false}
              size="small"
            />
          </Card>
        </Col>

        {/* Recent Orders */}
        <Col xs={24} md={12}>
          <Card title="Oxirgi buyurtmalar" bordered={false}>
            <Table
              columns={recentOrdersColumns}
              dataSource={dashboard.recentOrders}
              rowKey="id"
              pagination={false}
              size="small"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
